import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./navbar.css";
import {
  Pane,
  IconButton,
  CogIcon,
  majorScale,
  TrashIcon,
  TickIcon,
  MenuIcon,
} from "evergreen-ui";
import { BRAND_NAME, NAV_LOGO } from "../../Utils/variables";

const Navbar = () => {
  const [dropdownTogglke, setdropdownTogglke] = useState(true);
  return (
    <div className="navbarMain">
      <div className="LogoDivResponsive">
        <a href={process.env.REACT_APP_ANACITY_URL + "/"}>
          <img
            src={NAV_LOGO}
            alt={`${BRAND_NAME} logo`}
            id="NavLogoLeft"
          />
        </a>
        <div className="responsiveDropDownBtn">
          <i
            class="fa-solid fa-bars"
            onClick={() => {
              setdropdownTogglke(!dropdownTogglke);
            }}
          ></i>
        </div>
      </div>

      <div className="navbarLinkMainDiv" id={dropdownTogglke ? "navData" : ""}>
        {process.env.REACT_APP_PRODUCT === "ANACITY" && (
          <>
            <div class="dropdown">
              <button
                class="dropbtn"
                onClick={() => {
                  document.location.href =
                    process.env.REACT_APP_ANACITY_URL + "/";
                }}
              >
                <div class="dropbtndiv hover-underline-animation">
                  {/* <a
                href={process.env.REACT_APP_ANACITY_URL + "/"}
                className="homeAnc"
              > */}{" "}
                  Home
                  {/* </a> */}
                </div>
              </button>
            </div>

            <div class="dropdown">
              <button class="dropbtn">
                <div class="dropbtndiv">Services</div>{" "}
              </button>
              <div class="dropdown-content ">
                <a
                  href={
                    process.env.REACT_APP_ANACITY_URL +
                    "/multi-property-dashboard"
                  }
                >
                  Multi-Property Dashboard
                </a>
                <a
                  href={
                    process.env.REACT_APP_ANACITY_URL +
                    "/community-accounting-software"
                  }
                >
                  Financial Management
                </a>
                <a href={process.env.REACT_APP_ANACITY_URL + "/gatekeeper"}>
                  Gate Management
                </a>
                <a
                  href={
                    process.env.REACT_APP_ANACITY_URL + "/facility-mgmt-tools"
                  }
                >
                  Facility Management
                </a>
                <a
                  href={
                    process.env.REACT_APP_ANACITY_URL + "/community-helpdesk"
                  }
                >
                  Community Help Desk
                </a>
                <a
                  href={
                    process.env.REACT_APP_ANACITY_URL +
                    "/community-collaboration-tools"
                  }
                >
                  Communication
                </a>
              </div>
            </div>

            <div class="dropdown">
              <button
                class="dropbtn"
                onClick={() => {
                  document.location.href = "https://blog.anacity.com/";
                }}
              >
                <div class="dropbtndiv hover-underline-animation">
                  {/* <a
                href={process.env.REACT_APP_ANACITY_URL + "/"}
                className="homeAnc"
              > */}{" "}
                  Blogs
                  {/* </a> */}
                </div>
              </button>
            </div>

            <div class="dropdown">
              <button class="dropbtn">About Us</button>
              <div class="dropdown-content">
                <a href={process.env.REACT_APP_ANACITY_URL + "/management"}>
                  About Management
                </a>
                <a
                  href={process.env.REACT_APP_ANACITY_URL + "/anacity-in-news"}
                >
                  ANACITY in News
                </a>
              </div>
            </div>

            <div class="dropdown">
              <button
                class="dropbtn"
                onClick={() => {
                  document.location.href =
                    process.env.REACT_APP_ANACITY_URL + "/contact-us-for-demo";
                }}
              >
                <div class="dropbtndiv hover-underline-animation">
                  {/* <a
              href={process.env.REACT_APP_ANACITY_URL + "/"}
              className="homeAnc"
            > */}{" "}
                  Contact Us
                  {/* </a> */}
                </div>
              </button>
            </div>
          </>
        )}
        <div class="dropdown">
          <button class="dropbtn" id="navBold">
            Sign In
          </button>
          <div class="dropdown-content">
            <a href={process.env.REACT_APP_ANACITY_URL + "/auth/login"}>
              Member Sign In
            </a>
            <Link to={"/login"}>Vendor Sign In</Link>
          </div>{" "}
        </div>
      </div>
    </div>
  );
};

export default Navbar;
